import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioBoardStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-board', reducer),
        EffectsModule.forFeature([StudioBoardStoreEffects]),
    ],
    providers: [],
})
export class StudioBoardStoreModule { }
